const JsTabs = {
	init () {

		/*              __
	                   / _)         
	            .-^^^-/ /          
	        __/       /              
	        <__.|_|-|_|  

	        The Emagine Dinosaur says; "Material Design gots slidey indicators, why can't we?".          
	    */

	    if ( $('.subpage-tabs').length) {
	    	$(".subpage-tabs").RegisterTabBar("material-tabs").find("li.is-active").click();
	    }

	}
};

export default JsTabs;


// WEBPACK FOOTER //
// ./src/components/03-ui/subpage-tabs/subpage-tabs.js